import { ref, reactive, computed } from "vue";
import { createToaster } from "@meforma/vue-toaster";
import { isEmailValid } from "../helpers/fieldValidateHelper";
import { logActionRequest } from "../api/log";
import {useStore} from "vuex";

export function useState(initialValue) {

  const defaultState = JSON.parse(JSON.stringify(initialValue));
  const state = ref(initialValue);

  const setState = (newValue) => {
    if (typeof newValue === 'function') {
      state.value = newValue(state.value);
    } else {
      state.value = newValue;
    }
  };

  const clearState = () => {
    state.value = defaultState;
  }

  return [state, setState, clearState];
}

export function useToaster(position = 'top') {

  const toaster = createToaster({ position: position });

  return {
    alertSuccess: (message) => toaster.success(message),
    alertError: (message) => toaster.error(message)
  };
}

export function useForm(initialValues) {

  const fields = reactive({ ...initialValues })

  const formData = computed(() => {
    const data = {}
    Object.keys(fields).forEach(key => {
      data[key] = {
        value: fields[key].value,
        hasError: fields[key].hasError,
        errorText: fields[key].errorText
      }
    })
    return data
  });

  const fieldValidate = (field) => {
    if (field.rules) {
      for (let i = 0; i < field.rules.length; i++) {
        const rule = field.rules[i]
        if (rule === 'required') {
          if (field.value === '') {
            field.error = true
            field.errorText = 'Необходимо заполнить поле'
            break
          }
        } else if (rule === 'email') {
          if (!isEmailValid(field.value)) {
            field.error = true
            field.errorText = 'Некорректный e-mail адрес'
            break
          }
        }
      }
    }
  }

  const handleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target
      const field = fields[name]

      field.value = value
      field.error = false
      field.errorText = ''
      fieldValidate(field)
    }
  }

  const isValidate = () => {
    let error = false

    Object.keys(fields).forEach((key) => {
      const field = fields[key]
      fieldValidate(field)
      if (field.error) {
        error = true
      }
    })

    return !error
  }

  const resetForm = () => {
    Object.keys(fields).forEach((key) => {
      const field = fields[key]
      field.value = ''
      field.error = false
      field.errorText = ''
    })
  }

  return { fields, handleChange, isValidate, resetForm }
}

export function useLog() {

  const store = useStore();

  const recordLog = (text, phoneNumber = null) => {
    const phone = phoneNumber ?? store.state.auth.user.phone;
    return logActionRequest(phone, text);
  };

  const recordLogOrder = (orderNumber, text) => {
    return recordLog('[Заказ №' + orderNumber + '] ' + text);
  };

  return { recordLog, recordLogOrder }
}
